// Import source styles
import "../scss/app.scss";

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
//import { jarallax, jarallaxVideo } from 'jarallax';
import { Fancybox } from "@fancyapps/ui";

// Local imports

import { setupOptimizedScrollThrottle } from "./modules/_throttle.mjs";
import { validate } from './modules/_validate.mjs';
import { Disclosure } from "./modules/_disclosure.mjs";
import { Accordion } from "./modules/_accordion.mjs";
import { marquee } from "./modules/_marquee";
import { Dropdown} from "./modules/_dropdown.mjs";
import { Themeswitcher } from "./modules/_themeswitcher.mjs";
import { Textrotator } from "./modules/_textrotator.mjs";
import { Tablist } from "./modules/_tablist.mjs";
import { brandsSlider } from "./modules/_carousels.mjs";
import { countDown } from "./modules/_countdown.mjs";
import { headerscroll } from "./modules/_header.mjs";
import { scrollSpy } from "./modules/_scrollspy.mjs";


document.addEventListener("DOMContentLoaded", function () {

    AOS.init({startEvent: 'load', disable: 'mobile'});

    validate();
    marquee();
    brandsSlider();
    countDown();
    headerscroll();
    scrollSpy();
    setupOptimizedScrollThrottle();

    const disclosure = new Disclosure();
    const accordion = new Accordion();
    const dropdown = new Dropdown();
    const tablist = new Tablist();
    const themeswitcher = new Themeswitcher();
    const textrotator = new Textrotator();

    /*new Disclosure({ //language toggle doesn't work (no animation) when declaring this
        contents: '#js-based-disclosure-content',
        controls: '#js-based-disclosure-control',
        state: 'open'
        //todo: add animation option
        //todo: add modal option
    });*/

});
